module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": _vm.family && (_vm.link === undefined ? true : _vm.link) ? '/family/' + _vm.family.id : '#'
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "alt": "",
      "src": _vm.image || (_vm.family ? _vm.family.avatar : undefined) || '/network/static/img/default_family.jpg',
      "title": _vm.family && _vm.family.name
    }
  }), _vm._v(" "), (_vm.showName) ? _c('span', [_vm._v(_vm._s(_vm.family && _vm.family.name))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-373268e2!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/base/c-avatar.vue
// module id = 647
// module chunks = 1